<template>
  <div class="container">
    <div class="form">
      <h1>Lets get started!</h1>
      <span>Just one more email — a quick confirmation — before you say goodbye
          to your manual way of managing your building.</span>
      <input type="text" placeholder="Your work email" />
      <a href="#" class="btn btn-primary">Confirm</a>
      <p class="end">
        Already have an account?
        <router-link :to="{ name: 'login' }">Login instead</router-link>
      </p>
    </div>
    <div class="news">
      <img src="@/assets/nomado-trunk.svg" />
      <span class="badge" style="margin-top: 20px; align-self: flex-start;">
          new
      </span>
      <h2>entrée - smart visitor check-in!</h2>
      <p class="newsp">
        Help you organise and run your frondesk smoothly and focus on what it
        supposed to do - customer care. Automated and secure check-in specially
        designed for you!
      </p>
      <a href="#" class="end">Learn more</a>
    </div>
  </div>
</template>

<script>
export default {
    name: 'login-form',
    props: {
        msg: String
    }
};
</script>

<style lang="scss" scoped>
</style>
